import { render } from "./CatalogoGrupoDeLocaisDeTrabalho.vue?vue&type=template&id=53f12622&ts=true"
import script from "./CatalogoGrupoDeLocaisDeTrabalho.vue?vue&type=script&setup=true&lang=ts"
export * from "./CatalogoGrupoDeLocaisDeTrabalho.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src-next/modulos/governanca/grupo-de-locais-de-trabalho/catalogo/apresentacao/CatalogoGrupoDeLocaisDeTrabalho.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "53f12622"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('53f12622', __exports__)) {
    api.reload('53f12622', __exports__)
  }
  
  module.hot.accept("./CatalogoGrupoDeLocaisDeTrabalho.vue?vue&type=template&id=53f12622&ts=true", () => {
    api.rerender('53f12622', render)
  })

}


export default __exports__